<template>
    <div ref="loader" class="mt-2">
        <b-container class="container-lg">
            <b-row class="pb-2">
                <b-col class="text-start">
                    <h5><i class="fa-solid fa-gauge-high"></i> {{ $t('Dashboard') }}</h5>
                </b-col>
                <b-col class="text-end">
                    <button class="btn btn-light btn-sm" type="button" @click="refreshData">
                        <i :class="{'fa-spin': loading}"
                           class="fa-solid fa-arrows-rotate"></i>
                    </button>
                </b-col>
            </b-row>
            <b-card class="mb-2 border-bottom-1 rounded-bottom-1">
                <div class="row">
                    <b-button-group class="w-100">
                        <button class="w-1000 btn btn-light"
                                type="button"
                                @click="pushTo('dashboardsIndex')">
                            <i class="fa-solid fa-layer-group"></i>
                            {{ $t('Overview') }}
                        </button>
                        <!--<button type="button"
                                class="w-50 btn btn-light"
                                @click="pushTo('dashboardsStatuspagegroups')">
                          <i class="fa-solid fa-layer-group"></i>
                          {{ $t('Slas') }}
                        </button>-->

                    </b-button-group>
                </div>
                <div class="row">
                    <b-button-group class="w-100">
                        <button class="w-50 btn btn-light"
                                type="button"
                                @click="pushTo('dashboardsAlerts')">
                            <i class="fa-solid fa-bell"></i>
                            {{ $t('Alerts') }}
                        </button>
                        <button class="w-50 btn btn-light"
                                type="button"
                                @click="pushTo('dashboardsTacticals')">
                            <i class="fa-solid fa-chart-area"></i>
                            {{ $t('Tacticals') }}
                        </button>

                    </b-button-group>
                </div>
                <div class="row">
                    <b-button-group class="w-100">
                        <button class="w-50 btn btn-light"
                                type="button"
                                @click="pushTo('dashboardsStatuspages')">
                            <i class="fa-solid fa-info-circle"></i>
                            {{ $t('Statuspages') }}
                        </button>
                        <button class="w-50 btn btn-primary"
                                type="button"
                                @click="pushTo('dashboardsStatuspagegroups')">
                            <i class="fa-solid fa-layer-group"></i>
                            {{ $t('Statuspage groups') }}
                        </button>
                    </b-button-group>
                </div>
            </b-card>
            <b-list-group class="mt-2">
                <b-list-group-item>
                    <div class="row">
                        <div class="col">
                            <b-button v-b-toggle.filter class="m-0 w-100" variant="primary">
                                <i class="fa-solid fa-filter"></i>
                                {{ $t('Filter') }}
                            </b-button>
                        </div>
                    </div>
                    <b-collapse id="filter">

                        <div class="d-flex w-100 mt-2">
                            <b-form-input v-model="name" :placeholder="$t('name')"></b-form-input>
                        </div>
                        <div class="d-flex w-100 mt-2">
                            <b-form-input v-model="description" :placeholder="$t('description')"></b-form-input>
                        </div>
                        <div class="mt-2">
                            <b-button
                                class="w-100"
                                variant="outline-danger"
                                v-on:click="allFilter">{{ $t('filter.reset-filter') }}
                            </b-button>
                        </div>
                    </b-collapse>
                </b-list-group-item>
            </b-list-group>

            <!-- start new list -->
            <b-list-group
                v-for="statuspagegroup in statuspagegroups"
                v-bind:key="statuspagegroup.id"
                class="mt-2">


                <div class="flex-column align-items-start">
                    <div class="list-group-item flex-column align-items-start list-group-item-action ps-0">
                        <div class="d-flex flex-row min-h-110">
                            <div class="min-width-0">
                                <div class="row p-2">
                                    <div class="col-12 text-truncate h5">
                                        <span v-if="permissions.statuspagegroups?.view">
                                        <router-link
                                            :to="{name: 'statuspagegroupsDetails', params: {id: statuspagegroup.id}}"
                                            class="link-underline link-underline-opacity-0">
                                            {{ statuspagegroup.name }}
                                        </router-link>
                                        </span>
                                        <span v-else>
                                            {{ statuspagegroup.name }}
                                        </span>
                                    </div>
                                    <div v-if="statuspagegroup.description" class="col-12 text-truncate">
                                        <div class="row">
                                            <div class="col-12 text-truncate">
                                                <small>
                                                    {{ $t('Description') }}
                                                </small>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 bold text-truncate">
                                                <b>{{ statuspagegroup.description }}</b>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 text-truncate">
                                        <div class="row">
                                            <div class="col-12 text-truncate">
                                                <small>
                                                    {{ $t('Container') }}
                                                </small>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 text-truncate">
                                                <b>{{ statuspagegroup.container }}</b>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </b-list-group>
            <!-- end new list -->

            <b-list-group class="mt-3">
                <div v-if="statuspagegroups.length > 0">
                    <div class="d-flex w-100 justify-content-between">
                        <small>{{ $t('page') }} {{ paging.page }}</small>
                        <small>{{ $t('pagesize') }} {{ paging.limit }}</small>
                    </div>
                    <div class="d-flex w-100 justify-content-center mt-4">
                        <vue-awesome-paginate
                            v-model="paging.page"
                            :items-per-page="25"
                            :max-pages-shown="5"
                            :on-click="getIndex"
                            :total-items="paging.count"
                        />
                    </div>
                </div>
                <b-list-group-item v-if="statuspagegroups.length === 0">
                    <h5 class="mb-1">{{ $t('noitems') }}</h5>
                </b-list-group-item>
            </b-list-group>
        </b-container>
    </div>

</template>
<script>
import { debounce } from "../helpers";
import Priority from "./utils/Priority.vue";
import Servicestatus from "./utils/Servicestatus.vue";
import DateSwitch from "./utils/DateSwitch.vue";
import { useToast } from "vue-toastification";
import { VueAwesomePaginate } from "vue-awesome-paginate";
import { BListGroup } from 'bootstrap-vue-next';

export default {
    name: "DashboardsStatuspagegroups",
    components: {BListGroup, VueAwesomePaginate, DateSwitch, Servicestatus, Priority},
    data() {
        return {
            loading: true,
            requestStatus: false,
            listFilter: {
                filter: {
                    id: [],
                    name: '',
                    description: ""
                }
            },
            statuspagegroups: [],
            paging: {
                page: 1,
                pageCount: 1
            },
            name: '',
            description: '',
            permissions: {}
        }
    },
    mounted() {
        this.permissions = this.$store.state.permissions;
        this.getIndex();
    },
    methods: {
        pushTo: function(name) {
            this.$router.push({name: name});
        },
        getIndex: function(page = 1) {
            let loader = this.$loading.show();
            this.loading = true;
            axios.post('/statuspagegroups/index.json', {
                    filter: this.listFilter,
                    page: page
                },
                {
                    params: {}
                }
            )
                .then(response => {
                    this.requestStatus = true;
                    this.statuspagegroups = response.data.statuspagegroups.all_statuspagegroups ?? [];
                    this.permissions = response.data.permissions;
                    this.paging = response.data.statuspagegroups.paging ?? {
                        page: 1,
                        pageCount: 1
                    };
                })
                .catch(error => {
                    console.log(error)
                    useToast().error(this.$t('error'), {
                        timeout: 2000
                    });

                })
                .finally(() => {
                    loader.hide();
                    this.loading = false;
                });
        },
        allFilter: function() {
            this.resetFilter();
            this.getIndex();
        },
        resetFilter: function() {
            this.name = null;
            this.description = null;

            this.listFilter = {
                filter: {
                    id: [],
                    name: '',
                    description: ""
                }
            };
        },
        refreshData: function() {
            this.resetFilter();
            this.getIndex();
        },
        goBack: function() {
            this.$router.back();
        }
    },
    watch: {
        name: debounce(function(newValue) {
            if(newValue != null) {
                this.listFilter.filter.name = newValue;
                this.getIndex();
            }
        }, 700),
        description: debounce(function(newValue) {
            if(newValue != null) {
                this.listFilter.filter.description = newValue;
                this.getIndex();
            }
        }, 700)
    }

}
</script>

<style scoped>

</style>
